import { render, staticRenderFns } from "./ConfigDrawer.vue?vue&type=template&id=52b4001a"
import script from "./ConfigDrawer.vue?vue&type=script&lang=js"
export * from "./ConfigDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports